const Routes = {
  LOGIN: '/login',
  REPORT: '/report',
  NEWS_ADD: '/news',
  CAMPAIGN_EDIT: '/campaign',
};

export default Routes
